export const paths = {
  root: '/',
  login: '/signin', // must not clash with backend /login URL
  error: '/error',
  mySurveys: '/my-surveys',
  mySurveys_planned: '/my-surveys/planned',
  mySurveys_inProgress: '/my-surveys/in-progress',
  mySurveys_completed: '/my-surveys/completed',
  surveyIntro: '/new-survey/intro',
  surveyIntroFromVisit: '/new-survey/intro/:visitId',
  surveyIntroExistingSurvey: '/survey/:surveyId/intro',
  survey: '/survey/:surveyId',
  surveySection: '/survey/:surveyId/:sectionId/:subsectionId',
  surveyWrapUp: '/survey/:surveyId/wrap-up',
  viewSurvey: '/view/:surveyId',
  api: {
    profile: 'api/profile',
    surveyDefinition: 'api/survey-definition',
    surveyDefinitionPull: 'api/survey-definition/pull',
    mySurveys: 'api/my-surveys',
    mySurveysPull: 'api/my-surveys/pull',
    mySurveysPush: 'api/my-surveys/push',
    mySurveysWatch: 'api/my-surveys/watch',
    customerVisits: 'api/customer-visits'
  }
};
